import getFeatureToggle from './getFeatureToggle'
import getCookieValue from './getCookieValue'


export {
  getFeatureToggle,
  getCookieValue,
}
